import store from "@frameworks/web/redux/store";
import { UPDATE_ACCOUNT_DETAILS } from "@frameworks/web/redux/reducers/userdetail";
class UpdateAccountDetails {
    constructor() {
        this.dispatch = store.dispatch;
    }
    updateAccountDetails(data) {
        this.dispatch({
            type: UPDATE_ACCOUNT_DETAILS,
            payload: data,
        });
    }
}
export default UpdateAccountDetails;
